import sieviApi from "@/api/sieviApi"

export const obtainProgramResponsable = async ( { commit }, { id, campusId, hfsId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/programas/${id}/${campusId}/${hfsId}`)
        if (data.ok) {
            commit('setProgram', data.programas)
            return { ok: true, message: data.message }
        } else {
            commit('setProgram', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainProgramAuditor = async ( { commit }, { campusId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/programas/${campusId}`)
        if (data.ok) {
            commit('setProgram', data.programas)
            return { ok: true, message: data.message }
        } else {
            commit('setProgram', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainProgramsAdministrador = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/programas`)
        if (data.ok) {
            commit('setProgram', data.programas)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const createPrograms = async ( _, { form } ) => {
    const programForm = {
        nombre: form.name,
        campus_id: form.campusId
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/programas`, programForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
} 

export const editPrograms = async ( _, { form } ) => {
    const programForm = {
        nombre: form.name,
        campus_id: form.campusId
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/programas/${form.id}`, programForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deletePrograms = async ( _, idProgram ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.delete(`/api/administrador/programas/${idProgram}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainProgramReports = async ( { commit }, { campusId, hfsId } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/auditor/reportes/programas`, { campus: campusId, hfs: hfsId })
        if (data.ok) {
            commit('setProgram', data.programas)
            return { ok: true, message: data.message }
        } else {
            commit('setProgram', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainProgramReportsResponsable = async ( { commit }, { id, campusId, hfsId } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/responsable/reportes/programas`, { id: id, campus: campusId, hfs: hfsId })
        if (data.ok) {
            commit('setProgram', data.programas)
            return { ok: true, message: data.message }
        } else {
            commit('setProgram', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const generateReportViewProgram = async ({commit}, {idProgram, idPeriod, campusId}) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/programa/reporte/consultar/${idProgram}/${idPeriod}/${campusId}`)
        if (data.ok) {
            commit('setReport', data.reportes)
            return { ok: true, message: data.message }
        } else {
            commit('setReport', [])
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}